import { localStorageConstants } from "../Services/LocalStorageServices";

const getIsRedirection = () => {
  return (
    !!localStorage.getItem(localStorageConstants.SrcRef) &&
    !!localStorage.getItem(localStorageConstants.Redirect) &&
    !!localStorage.getItem(localStorageConstants.TxnId)
  );
};
export default getIsRedirection;
